import type { FeatureFlagKey } from '@discover/domain'
import { useFeatureFlagsStore } from '../stores/featureFlagsStore'

/**
 * Hook to check if a feature flag is enabled
 * Reads from the feature flags store which is automatically populated from backend responses
 * @param flagKey - The feature flag key to check
 * @param organizationId - Optional organization ID (kept for backward compatibility, not used)
 */
export function useFeatureFlag(
	flagKey: FeatureFlagKey,
	_organizationId?: string, // Kept for backward compatibility, not used
): {
	isEnabled: boolean
	isLoading: boolean
} {
	const isEnabled = useFeatureFlagsStore((state) => state.isEnabled(flagKey))
	const lastUpdated = useFeatureFlagsStore((state) => state.lastUpdated)

	// If flags haven't been loaded yet, show loading state
	const isLoading = !lastUpdated

	return {
		isEnabled: isLoading ? false : isEnabled,
		isLoading,
	}
}
